import { useUser } from "@accredo/fe-shared/hooks/user.js";
import policy from "../../policies/DocumentCategoryMappingPolicy.js";

export function useDocumentCategoryMappingPermissions() {
  const { user } = useUser();
  return {
    canCreate: () => policy.create({ user }),
    canEdit: () => policy.update({ user }),
    canDelete: () => policy.delete({ user }),
    canReapply: () => policy.reapply({ user }),
  };
}
